export const style = {
  typography: {
    color: 'primary.text',
    sx: {
      color: 'primary.text',
    },
  },
  boxInfo: {
    typography: {
      variant: 'h6',
      sx: {
        color: 'primary.text',
      },
    },
  },
  boxLastRun: {
    typography: {
      variant: 'caption',
      sx: {
        color: 'primary.text',
      },
    },
  },
} as const;
